import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

import Text from '../Text/Text';
import Button from '../Button/Button';
import ButtonTypes from '../../constants/buttonTypes';
import { ReactComponent as IconClose } from '../../assets/icon/ic_cross.svg';
import { IconLoading } from '../../assets/icon';

const Modal = ({
  visible, toggleVisible, children, title, onSave,
  canSave, saveText, subTitle, additionalButton, hideSaveBtn,
  hideCloseBtn, showFooter, cancelButtonText, loading,
}) => {
  ReactModal.setAppElement('#root');

  return (
    <ReactModal
      isOpen={visible}
      className="border-none bg-[rgba(30,30,45,.3)] max-w-[80%]"
      overlayElement={(props, contentElement) => (
        <div
          className="fixed w-full h-full bg-[rgba(30,30,45,.3)] top-0 left-0 z-[10] overflow-auto"
        >
          {contentElement}
        </div>
      )}
    >
      <div className="absolute flex justify-center items-center w-full min-h-full top-0 left-0 overflow-auto">
        <div
          className="m-[10px_0] sm:m-[20px_0] h-max justify-center items-center flex flex-col
          w-[95%] sm:w-auto min-w-0 sm:min-w-[350px] z-[10]
          bg-white dark:bg-background-dark rounded-[8px] max-w-[95%] sm:max-w-[80%] shadow-default
          animate__animated animate__fadeInDown animate__faster"
        >
          <div
            className="flex flex-row items-start justify-between p-[15px] sm:p-[23px]
            border-b border-whiteHover dark:border-[#1b263b] w-full"
          >
            <div>
              <Text text={title} bold textStyle="text-[19px]" />
              {subTitle && <Text text={subTitle} muted />}
            </div>
            <Button
              onClick={toggleVisible}
              containerStyle="p-[5px]"
              icon={<IconClose />}
              type={ButtonTypes.WHITE}
            />
          </div>
          <div className="p-[15px] sm:p-[25px] w-full">
            {visible && children}
          </div>
          {showFooter && (
            <div
              className="flex flex-col-reverse sm:flex-row justify-end gap-[10px] p-[15px] sm:p-[25px]
              border-t border-whiteHover dark:border-[#1b263b] w-full"
            >
              {additionalButton && <div>{additionalButton}</div>}
              {!hideCloseBtn && (
                <Button
                  text={cancelButtonText}
                  onClick={toggleVisible}
                  containerStyle="w-full sm:w-auto"
                  type={ButtonTypes.LIGHT}
                />
              )}

              {!hideSaveBtn && (
                <Button
                  text={saveText}
                  onClick={onSave}
                  disabled={loading || canSave}
                  containerStyle="w-full sm:w-auto"
                  icon={loading ? <div className="spin"><IconLoading /></div> : undefined}
                />
              )}
            </div>
          )}

        </div>
      </div>
    </ReactModal>
  );
};

Modal.propTypes = {
  visible: PropTypes.bool,
  canSave: PropTypes.bool,
  hideSaveBtn: PropTypes.bool,
  hideCloseBtn: PropTypes.bool,
  showFooter: PropTypes.bool,
  loading: PropTypes.bool,
  toggleVisible: PropTypes.func,
  onSave: PropTypes.func,
  children: PropTypes.node,
  additionalButton: PropTypes.node,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  saveText: PropTypes.string,
  cancelButtonText: PropTypes.string
};

Modal.defaultProps = {
  toggleVisible: () => {},
  onSave: () => {},
  visible: false,
  hideSaveBtn: false,
  hideCloseBtn: false,
  loading: false,
  canSave: true,
  showFooter: true,
  children: undefined,
  additionalButton: undefined,
  title: '',
  subTitle: undefined,
  saveText: 'Save changes',
  cancelButtonText: 'Close',
};

export default Modal;
